import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Trash2, Trophy, Flag, Users } from "lucide-react";

export default function AdminEnrollmentsPanel() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/admin/enrollments").then((r) => setList(r.data)).catch(() => toast.error("Errore nel caricamento")).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    try { await api.delete(`/enrollments/${id}`); toast.success("Iscritto rimosso"); load(); }
    catch { toast.error("Errore"); }
  };
  const clearAll = async () => {
    if (!window.confirm("Cancellare TUTTI gli iscritti dell'app?")) return;
    try { const r = await api.delete("/admin/enrollments"); toast.success(`Cancellati ${r.data.deleted}`); load(); }
    catch { toast.error("Errore"); }
  };

  return (
    <div data-testid="admin-enrollments-panel">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
        <span className="flex items-center gap-2 text-sm font-bold tracking-[0.15em] uppercase text-zinc-300">
          <Users className="h-5 w-5 text-yellow-400" /> Tutti gli iscritti ({list.length})
        </span>
        {list.length > 0 && (
          <button onClick={clearAll} data-testid="admin-clear-all-btn"
            className="inline-flex items-center gap-2 border border-red-500/40 text-red-400 hover:bg-red-500/10 text-xs font-bold uppercase tracking-wider px-4 py-2.5 transition-colors duration-200">
            <Trash2 className="h-4 w-4" /> Cancella tutti
          </button>
        )}
      </div>

      {loading ? (
        <p className="text-zinc-500 py-10 text-center">Caricamento…</p>
      ) : list.length === 0 ? (
        <p className="text-zinc-500 py-10 text-center" data-testid="admin-no-enrollments">Nessun iscritto al momento.</p>
      ) : (
        <div className="border border-zinc-800" data-testid="admin-enrollments-list">
          <div className="grid grid-cols-12 gap-2 px-5 py-3 bg-zinc-900 text-[10px] font-bold tracking-[0.2em] uppercase text-zinc-500">
            <div className="col-span-4">Pilota</div>
            <div className="col-span-2">Tipo</div>
            <div className="col-span-5">Dove</div>
            <div className="col-span-1 text-right">Azione</div>
          </div>
          {list.map((e, i) => (
            <div key={e.id} data-testid={`admin-enroll-row-${i}`}
              className={`grid grid-cols-12 gap-2 px-5 py-4 items-center border-t border-zinc-800 ${i % 2 ? "" : "bg-zinc-900/50"}`}>
              <div className="col-span-4 font-heading font-bold text-zinc-50 truncate">
                {e.name}{e.admin_added && <span className="ml-2 text-[10px] text-cyan-400">(admin)</span>}
              </div>
              <div className="col-span-2 flex items-center gap-1.5 text-xs text-zinc-400">
                {e.type === "championship" ? <Trophy className="h-3.5 w-3.5 text-yellow-400" /> : <Flag className="h-3.5 w-3.5 text-cyan-400" />}
                {e.type === "championship" ? "Campionato" : "Gran Premio"}
              </div>
              <div className="col-span-5 text-sm text-zinc-300 truncate">
                {e.target_name}
                {e.type === "event" && e.championship_name && <span className="text-zinc-500"> · {e.championship_name}</span>}
              </div>
              <div className="col-span-1 text-right">
                <button onClick={() => del(e.id)} data-testid={`admin-del-enroll-${i}`}
                  className="text-zinc-500 hover:text-red-400 transition-colors duration-200">
                  <Trash2 className="h-4 w-4" />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
